import React from "react"
import { Form as BootstrapForm } from "react-bootstrap"
import classNames from "classnames"
import { connect } from "react-redux"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Tooltip } from "@material-ui/core"
import {faInfoCircle} from "@fortawesome/free-solid-svg-icons/faInfoCircle";
import { FormikProps } from "formik/dist/types";
import { DEFAULT_TOOLTIP_PROPS } from "../../../helpers/tooltipHelper"
import {ConfigurationsType} from "../../../types/configurations";
import BasicSwitch from "./shared/BasicSwitch";
import {updateIsInterferometricStackSearchAction} from "../../../state/product/actions";
import {
  isStackEnabledOnMission
} from "../../../helpers/interferometricStackHelper";
import translations from "../../../translations";
import {AppParametersType} from "../../../types/app";

interface PropsType {
  configurations: ConfigurationsType,
  scopeConfigurationFields: string,
  disabled: boolean,
  formProps: FormikProps<any>,
  isInterferometricStackSearch: boolean,
  updateIsInterferometricStackSearchActionHandler: any,
  language: string,
  appParameters: AppParametersType
}

const InterferometricStackField = (props: PropsType) => {
  const {
    configurations,
    scopeConfigurationFields,
    disabled,
    formProps,
    isInterferometricStackSearch,
    updateIsInterferometricStackSearchActionHandler,
    language,
    appParameters
  } = props;

  const {
    values,
  } = formProps;

  return (
    <div
      className={classNames("row mx-0 mb-3", {
        "d-none": !isStackEnabledOnMission(configurations, appParameters, scopeConfigurationFields, values)
      })}
    >
      <BootstrapForm.Label className="m-0 px-0 col-3 d-flex">
        <Tooltip
          {...DEFAULT_TOOLTIP_PROPS}
          title={translations("infoLabelInterferometrickStack", appParameters.language)}
          placement="right-end"
        >
          <span className="title">
            <svg className="label-icon">
              <use xlinkHref="#stack-images" fill="#9A9BA6" />
            </svg>
            <span>{translations("interferometricStackSearchFilters", language)}</span>
            <FontAwesomeIcon
              icon={faInfoCircle}
              className="ml-1"
            />
          </span>
        </Tooltip>
      </BootstrapForm.Label>
      <BootstrapForm.Group className="col-9 m-0 pr-0 switch-container d-flex justify-content-end">
        <BasicSwitch
          fieldName="interferometricStack"
          value={isInterferometricStackSearch}
          disabled={disabled}
          onChange={(value) => updateIsInterferometricStackSearchActionHandler(value)}
        />
      </BootstrapForm.Group>
    </div>
  );
};

const mapStateToProps = (state) => ({
  isInterferometricStackSearch: state.product.isInterferometricStackSearch,
  language: state.application.appParameters.language,
  appParameters: state.application.appParameters,
});

const mapDispatchToProps = (dispatch) => ({
  updateIsInterferometricStackSearchActionHandler: (toggle) => dispatch(updateIsInterferometricStackSearchAction(toggle))
});

export default connect(mapStateToProps, mapDispatchToProps)(InterferometricStackField);
